// removed by extract-text-webpack-plugin
module.exports = {"head":"src-layouts----Header-module---head---3T62_","logo":"src-layouts----Header-module---logo---1BZp_","content":"src-layouts----Header-module---content---1XSHz","text":"src-layouts----Header-module---text---1qHaI","text_content":"src-layouts----Header-module---text_content---1PuSl"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Header.module.css
// module id = 614
// module chunks = 114276838955818